module.exports = __webpack_public_path__ + "static/flags/pt-c66a8e2c097db7957f07cd4204cb66b6.svg";